import { createCustomAction } from 'typesafe-actions';

import { AuthenticationMethod } from '../../utils/Api';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$REMOVE_PAYMENT_GATEWAY_TOKEN/REQUESTED';
const BLOCKED = '$REMOVE_PAYMENT_GATEWAY_TOKEN/BLOCKED';
const APPROVED = '$REMOVE_PAYMENT_GATEWAY_TOKEN/APPROVED';
const SUCCEEDED = '$REMOVE_PAYMENT_GATEWAY_TOKEN/SUCCEEDED';
const FAILED = '$REMOVE_PAYMENT_GATEWAY_TOKEN/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      token: string;
      authenticationMethod?: AuthenticationMethod;
    }>(type);
};

const succeed = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      tokens: PaymentGateWayToken[];
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, succeed),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
